interface HeroProps {
  title_line1: string
  title_line2: string
  tagline: string
  cta_contact: string
  cta_services: string
}

export default function Hero({
  title_line1,
  title_line2,
  tagline,
  cta_contact,
  cta_services,
}: HeroProps) {
  const handleAnchor = (
    e: React.MouseEvent<HTMLAnchorElement>,
    anchor: string
  ) => {
    e.preventDefault()
    const target = document.getElementById(anchor)
    if (target) {
      target.scrollIntoView({ behavior: "smooth", block: "start" })
    }
  }

  return (
    <section className="min-h-screen flex items-center justify-center bg-light relative">
      <div className="container mx-auto px-6 text-center">
        <div className="mb-12">
          <h1 className="text-6xl md:text-8xl font-bold text-contrast tracking-tight">
            {title_line1}
            <br />
            <span className="font-light">{title_line2}</span>
          </h1>
        </div>

        <p className="text-xl md:text-2xl text-content max-w-2xl mx-auto mb-12">
          {tagline}
        </p>

        <div className="flex gap-6 justify-center flex-wrap">
          <a
            href="#contact"
            onClick={(e) => handleAnchor(e, "contact")}
            className="px-8 py-4 bg-contrast text-light font-medium tracking-wide hover:bg-secondary transition-all duration-300"
          >
            {cta_contact}
          </a>
          <a
            href="#services"
            onClick={(e) => handleAnchor(e, "services")}
            className="px-8 py-4 border border-contrast text-contrast font-medium tracking-wide hover:bg-contrast hover:text-light transition-all duration-300"
          >
            {cta_services}
          </a>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="w-6 h-6 text-content"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={1.5}
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M19.5 8.25l-7.5 7.5-7.5-7.5"
          />
        </svg>
      </div>
    </section>
  )
}
